module.exports = __webpack_public_path__ + "static/media/403JamesPBrawleyDrNW_2018-06-12_79.ec3e3c6e.jpg";